// extracted by mini-css-extract-plugin
export default {"span":"comments_span__Kp6-m","spanUser":"comments_spanUser__IVoVi"};